import { appendLocaleSources } from '../../hooks/useTranslate'
import OptionPresenter from '../../api/optionPresenter'

appendLocaleSources({
  [OptionPresenter.urn]: {
    page: {
      title: 'Опции',
    },
    modal: {
      title: {
        create: 'Создать опцию',
        update: 'Обновить опцию',
      },
    },
    action: {
      create: 'Добавить опцию',
    },
    message: {
      confirmDelete: `Вы действительно хотите удалить эту опцию?`,
    },
  },
}, 'ru')

appendLocaleSources({
  [OptionPresenter.urn]: {
    page: {
      title: 'Options',
    },
    modal: {
      title: {
        create: 'Create Option',
        update: 'Update Option',
      },
    },
    action: {
      create: 'Add Option',
    },
    message: {
      confirmDelete: `Are you sure you want to delete this option?`,
    },
  },
}, 'en')

appendLocaleSources({
  [OptionPresenter.urn]: {
    page: {
      title: 'Tanlovlar',
    },
    modal: {
      title: {
        create: 'Tanlovni yaratish',
        update: 'Tanlovni yangilash',
      },
    },
    action: {
      create: 'Tanlov qo‘shish',
    },
    message: {
      confirmDelete: `Siz haqiqatan ham ushbu tanlovni o‘chirmoqchimisiz?`,
    },
  },
}, 'uz')


